module.exports = __webpack_public_path__ + "assets/collegiatessinside-regular-webfont-e32a6b5aa16561fdc713fa27ed311d8d.svg";